// View statistics for the agent's dashboard: view, time spent, rooms visited, errors.
// Batched, sent with sendBeacon on page hide; no cookies, no personal data.

export class Analytics {
    /** `ref`: the page the tour is shown on, where that is not the referrer (the website's own demo, no iframe) */
    constructor(apiBase, tourId, viewToken, ref = null) {
        this.ref = ref;
        this.url = `${apiBase}/v1/tours/${encodeURIComponent(tourId)}/events`;
        this.session = Math.random().toString(36).slice(2, 12);
        this.token = viewToken || null;
        this.queue = [];
        this.rooms = new Map();      // room -> seconds
        this.current = null;
        this.lastTick = performance.now();
        this.active = 0;
    }

    event(type, data = {}) {
        this.queue.push({ type, t: Math.round(performance.now()), ...data });
        if (type === 'view' || type === 'error') this.flush();
    }

    room(id) {
        this.current = id;
    }

    start() {
        setInterval(() => this._tick(), 1000);
        setInterval(() => this.flush(), 30000);
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'hidden') this.flush(true);
        });
        window.addEventListener('pagehide', () => this.flush(true));
    }

    _tick() {
        if (document.visibilityState !== 'visible') return;
        this.active++;
        if (this.current) this.rooms.set(this.current, (this.rooms.get(this.current) || 0) + 1);
    }

    flush(final = false) {
        if (!this.queue.length && !final) return;
        const body = JSON.stringify({
            session: this.session,
            token: this.token,
            // The agent's page that embeds the iframe, for the referrer statistics
            ref: this.ref || document.referrer || null,
            activeSeconds: this.active,
            rooms: Object.fromEntries(this.rooms),
            events: this.queue.splice(0)
        });
        if (final && navigator.sendBeacon) {
            navigator.sendBeacon(this.url, new Blob([body], { type: 'text/plain' }));
        } else {
            fetch(this.url, { method: 'POST', body, keepalive: true, headers: { 'content-type': 'text/plain' } }).catch(() => {});
        }
    }
}
